export { default } from './Hint'
export type { HintProps } from './Hint'
